import { render, staticRenderFns } from "./ProductColorButton.vue?vue&type=template&id=2140eb28&"
import script from "./ProductColorButton.js?vue&type=script&lang=js&"
export * from "./ProductColorButton.js?vue&type=script&lang=js&"
import style0 from "./ProductColorButton.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports